import { c as _c } from "react/compiler-runtime";
import type { Call, CallStatus } from "@signalwire/js";
import type { Subscription } from "rxjs";
import { useEffect } from "react";
const END_STATUSES = new Set<CallStatus>(["disconnected", "destroyed", "failed"]);
interface UseCallEventListenersOptions {
  call: Call | null;
  /** Receives the status that ended the call (disconnected, destroyed, failed). */
  onCallEnded: (status: CallStatus) => void;
  onConnected?: () => void;
}
export function useCallEventListeners(t0) {
  const $ = _c(5);
  const {
    call,
    onCallEnded,
    onConnected
  } = t0;
  let t1;
  let t2;
  if ($[0] !== call || $[1] !== onCallEnded || $[2] !== onConnected) {
    t1 = () => {
      if (!call) {
        return;
      }
      const subs = [];
      subs.push(call.status$.subscribe(status => {
        if (END_STATUSES.has(status)) {
          onCallEnded(status);
        }
        if (status === "connected" && onConnected) {
          onConnected();
        }
      }));
      return () => {
        subs.forEach(_temp);
      };
    };
    t2 = [call, onCallEnded, onConnected];
    $[0] = call;
    $[1] = onCallEnded;
    $[2] = onConnected;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
}
function _temp(s) {
  return s.unsubscribe();
}